export const PauseAction = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 2C6.10457 2 7 2.89543 7 4V12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12V4C3 2.89543 3.89543 2 5 2Z'
      fill='inherit'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 2C12.1046 2 13 2.89543 13 4V12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12V4C9 2.89543 9.89543 2 11 2Z'
      fill='inherit'
    />
  </svg>
);
